export const ALARMS_SECTION_EVENT = 'canvas-agent:alarms:section';
export const ACTIVE_ALARMS_SECTION_EVENT = 'canvas-agent:alarms:active-section';
export const HISTORICAL_ALARMS_SECTION_EVENT = 'canvas-agent:alarms:historical-section';
export const SWITCH_EVENTS_SECTION_EVENT = 'canvas-agent:alarms:switch-section';
export const ACTIVE_ALARMS_FILTER_EVENT = 'canvas-agent:alarms:active-filter';
export const HISTORICAL_ALARMS_FILTER_EVENT = 'canvas-agent:alarms:historical-filter';
export const SWITCH_EVENTS_FILTER_EVENT = 'canvas-agent:alarms:switch-filter';
export const ACTIVE_ALARMS_FOCUS_EVENT = 'canvas-agent:alarms:active-focus';
export const HISTORICAL_ALARMS_FOCUS_EVENT = 'canvas-agent:alarms:historical-focus';
export const SWITCH_EVENTS_FOCUS_EVENT = 'canvas-agent:alarms:switch-focus';
export const ACTIVE_ALARMS_ACK_MODAL_EVENT = 'canvas-agent:alarms:acknowledge-modal';
export const ACTIVE_ALARMS_CONFIGURE_MODAL_EVENT = 'canvas-agent:alarms:configure-modal';
export const HISTORICAL_ALARMS_DELETE_MODAL_EVENT = 'canvas-agent:alarms:historical-delete-modal';
